module.exports = __webpack_public_path__ + "static/media/icon_nasalInhalator.b5bb9961.svg";